<template>
  <div class="thumbnail">
    <div class="topimg">
      <img
        :src="topimg"
        alt=""
      >
    </div>
    <div class="bottom">
      <div class="img">
        <img
          v-for="item in list"
          :key="item"
          :src="item"
          alt=""
        >
      </div>
      <div
        class="omit"
        v-if="list.length >= 3"
      >···</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "thumbnail",
  props: {
    tableData: Object,
    scope: Object
  },
  data() {
    return {};
  },
  computed: {
    topimg() {
      return (
        this.scope.row[this.tableData.bind] &&
        this.scope.row[this.tableData.bind][0]
      );
    },
    list() {
      return this.scope.row[this.tableData.bind]
        ? this.scope.row[this.tableData.bind].slice(1, 4)
        : [];
    }
  },
  mounted() {},
  methods: {},
  components: {}
};
</script>

<style scoped lang="scss">
.thumbnail {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 6px 0px;
  .topimg {
    width: 100px;
    height: 70px;
    overflow: hidden;
    border-radius: 4px;
    img {
      width: 100px;
      border-radius: 2px;
    }
  }
  .bottom {
    width: 100px;
    height: 26px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 4px 0;
    .img {
      border-radius: 2px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      img {
        width: 26px;
        height: 26px;
        margin: 0 1px;
        border-radius: 2px;
      }
    }
    .omit {
      width: 26px;
      height: 100%;
      text-align: center;
      color: #999;
      font-size: 20px;
    }
  }
}
</style>
